var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var Agitavit;
(function (Agitavit) {
    /**
     * Common utilities.
     */
    var Utilities = /** @class */ (function () {
        function Utilities() {
        }
        /**
         * Returns a function, that, as long as it continues to be invoked, will not
         * be triggered. The function will be called after it stops being called for
         * N milliseconds. If `immediate` is passed, trigger the function on the
         * leading edge, instead of the trailing.
         * @param func
         * @param wait
         * @param immediate
         */
        Utilities.debounce = function (func, wait, immediate) {
            var timeout;
            return function () {
                var context = this, args = arguments;
                var later = function () {
                    timeout = null;
                    if (!immediate) {
                        func.apply(context, args);
                    }
                };
                var callNow = immediate && !timeout;
                clearTimeout(timeout);
                timeout = window.setTimeout(later, wait);
                if (callNow) {
                    func.apply(context, args);
                }
            };
        };
        /**
         * Returns an object with the keys and values of comparison object, where they differ from reference object.
         * @param source The source object to compare to.
         * @param comparison The object to compare.
         */
        Utilities.objectDiff = function (source, comparison) {
            if (source === null
                || source === undefined
                || comparison === null
                || comparison === undefined) {
                return null;
            }
            var res = {};
            var any = false;
            Object.keys(comparison).forEach(function (t) {
                if (source[t] !== comparison[t]) {
                    res[t] = comparison[t];
                    any = true;
                }
            });
            return any && res || null;
        };
        Utilities.fetch = function (first, second) {
            return new Promise(function (resolve, reject) {
                $.ajax(first, second)
                    .done(function (t) { return resolve(t); })
                    .fail(function (t) { return reject(t); });
            });
        };
        /**
         * Sends an AJAX request with JSON data to an endpoint and returns a promise.
         * @param url Target endpoint URL.
         * @param data Data to send to the endpoint. May be omitted.
         * @param settings AJAX call configuration. Overrides default values.
         */
        Utilities.postJson = function (url, data, settings) {
            return Utilities.fetch(__assign({ url: url, method: "POST", dataType: "JSON", async: true, data: data }, settings));
        };
        /**
         * Gets a resource by name. Returns null if the resources does not exist.
         * @param name Resource name.
         */
        Utilities.getResource = function (name) {
            var obj = $.agito.resources.getResource(name);
            return obj || null;
        };
        Utilities.handleResponseMessages = function (formElement, data) {
            // check if there are any messages
            if (!data || !data.userMessages) {
                return;
            }
            // find closest message placeholder
            var messagesPlaceholder = null;
            var form = formElement.closest(".hrm-page-placeholder, .modal-dialog");
            if (form != null) {
                messagesPlaceholder = form.querySelector(".hrm-page-messages-placeholder");
            }
            if (messagesPlaceholder == null) {
                messagesPlaceholder = document.body.querySelector(".hrm-page-messages-placeholder");
            }
            // render messages
            $.agito.hrmPage.handleAjaxError($(messagesPlaceholder), data);
        };
        /**
         * Returns a unique id within page. Can be used as id on html elements.
         */
        Utilities.getUniqueId = function () {
            Utilities.idCount++;
            return "ag-cid-" + Utilities.idCount.toString();
        };
        Object.defineProperty(Utilities, "selectedLanguage", {
            /**
             * Gets the users selected language.
             * @returns {}
             */
            get: function () {
                return $.agito.selectedLanguage;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Utilities, "defaultLanguage", {
            /**
             * Gets the users default language.
             * @returns {}
             */
            get: function () {
                return $.agito.defaultLanguage;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Utilities, "baseUrl", {
            /**
             * Gets the application base url.
             * @returns {}
             */
            get: function () {
                return $.agito.baseUrl;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Utilities, "currentServerCulture", {
            /**
             * Gets the current server culture.
             * @returns {}
             */
            get: function () {
                return $.agito.currentServerCulture;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Utilities, "rememberGridFilters", {
            get: function () {
                return $.agito.rememberGridFilters;
            },
            enumerable: false,
            configurable: true
        });
        /**
         * Decorator which adds an requirement to class to statically implement given interface.
         */
        Utilities.staticImplements = function () {
            return function (constructor) { };
        };
        Utilities.getEntityInstanceId = function (formChildElement) {
            var form = formChildElement.closest("form");
            if (!form) {
                return null;
            }
            var inputElement = form.querySelector("input[name='EntityInstanceId']");
            if (inputElement) {
                return inputElement.value;
            }
            return null;
        };
        Utilities.getTableRowId = function (tableChildElement) {
            var el = tableChildElement.closest("tr");
            if (el) {
                return $(el).attr("key") || $(el).attr("data-id");
            }
            return null;
        };
        Utilities.localizeResourceKey = function (resourceKey) {
            return $.agito.resources.getResource(resourceKey);
        };
        Utilities.openBrowserTab = function (url) {
            UrlHelpers.OpenBrowserTab(url);
        };
        Utilities.openQuickEditDialog = function (entityId, entityInstanceId, parentEntityAttributeId, parentEntityInstanceId, successCallback, formGroupId, parameters) {
            $.agito.hrmPage.quickEditDialog(entityId, entityInstanceId, parentEntityAttributeId, parentEntityInstanceId, successCallback, formGroupId, parameters);
        };
        Utilities.openDeleteDialog = function (entityId, entityInstanceIds, successCallback) {
            $.agito.hrmPage.openDeleteDialog(entityId, entityInstanceIds, entityInstanceIds.length, successCallback);
        };
        /**
         * HTML encodes given string.
         * @param html
         */
        Utilities.htmlEncode = function (html) {
            return $.ig.encode(html || "");
        };
        Utilities.format = function (string, object) {
            if (!string) {
                return "";
            }
            return string.replace(/{([^{}]*)}/g, function (match, group_match) {
                var data = object[group_match];
                return typeof data === "string" ? data : match;
            });
        };
        Utilities.idCount = 0;
        return Utilities;
    }());
    Agitavit.Utilities = Utilities;
})(Agitavit || (Agitavit = {}));
//# sourceMappingURL=utilities.js.map